var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Order-Ascending-Numbers-Fill--Streamline-Outlined-Fill-Expansion-Set.svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Order Ascending Numbers Fill Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order-ascending-numbers-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5467 18.5333L6.7733 23.76L12 18.5333L10.1707 16.6713L8.08 18.762V0.24H5.4667V18.762L3.376 16.704L1.5467 18.5333ZM21.1467 10.6933H18.5333V2.8533H17.2267V0.24H21.1467V10.6933ZM22.4533 23.76H15.2667V19.84C15.2667 19.1213 15.5225 18.5061 16.0343 17.9943C16.5462 17.4825 17.1613 17.2267 17.88 17.2267H19.84V15.92H15.2667V13.3067H19.84C20.5587 13.3067 21.1738 13.5625 21.6857 14.0743C22.1975 14.5862 22.4533 15.2013 22.4533 15.92V17.2267C22.4533 17.9453 22.1975 18.5605 21.6857 19.0723C21.1738 19.5842 20.5587 19.84 19.84 19.84H17.88V21.1467H22.4533V23.76Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/Order.8435abbdb695bfccb97a3d62d61faeb2.svg";
export { ForwardRef as ReactComponent };